import React from 'react';
import './settingsItem.scss';
import {Icon} from '@iconify/react';

export type SettingsItemProps = {
    title: string;
    description: string;
    icon?: string;
    trailing: JSX.Element;
};

function SettingsItem({title, description, icon, trailing}: SettingsItemProps): JSX.Element {
    return (
        <div className="c-settingsItem">
            <div className="u-flex u-h-between u-v-center u-gap-4">
                {icon && <Icon className="c-settingsItem__icon" icon={icon} />}
                <div className="u-flex u-flex-col">
                    <p className="c-settingsItem__title">{title}</p>
                    <p className="c-settingsItem__description">{description}</p>
                </div>
                <div style={{flex: '1'}} />
                <div className="c-settingsItem__trailing">{trailing}</div>
            </div>
        </div>
    );
}

export default SettingsItem;
